<template>
  <div class="cash-withdrawal" style="padding-top: 1rem">
    <!--<navTitle title="绑定电子钱包"></navTitle>-->
    <navTitle
      :title="
        $router.app._route.query.ti
          ? $router.app._route.query.ti
          : 'Link e-wallet'
      "
    ></navTitle>

    <div class="row-wrap">
      <div class="row-T1">Select e-wallet</div>
      <div class="row">
        <div class="row-name">Service provider</div>
        <select class="select" v-model="cashName">
          <option value="">Please select service provider</option>
          <option
            v-for="(item, index) in payList"
            :key="index"
            :value="item.name"
          >
            <!--<img :src="item.icon" alt="">-->

            {{ item.name }}</option
          >
        </select>
      </div>
    </div>
    <div v-if="showSubmit">
      <div class="row-wrap">
        <div class="row-T1">E-wallet details</div>
        <div class="row">
          <div class="row-name">Account</div>
          <input class="input" placeholder="Enter your account name" v-model="post.name" />
        </div>
        <div class="row">
          <div class="row-name">Phone</div>
          <input
            class="input"
            placeholder="Format:09*********"
            v-model="post.phone"
          />
        </div>
      </div>
      <div class="tips">
        *Please check and confirm all details are correct, incorrect details will delay top up.
      </div>
      <div class="submit bg-color-blue" @click="submitted">Bind</div>
    </div>

    <div v-if="!showSubmit && cashName">
      <div class="row-wrap">
        <div class="row-T1">Unbind cash account</div>
        <div class="row">
          <div class="row-name">Account</div>
          <input
            class="input"
            placeholder="Please enter your account"
            v-model="select_cash.account"
            disabled="disabled"
          />
        </div>
        <!--<div class="row">-->
          <!--<div class="row-name">Phone</div>-->
          <!--<input-->
            <!--class="input"-->
            <!--placeholder="Please enter the phone number of the binding"-->
            <!--v-model="removeData.phone"-->
          <!--/>-->
        <!--</div>-->
      </div>

      <div class="tips">
        *If you want to bind other account, please contact customer service to unbind.

        <!--*Please unbind current account, if you do not know the phone number binded, please contact customer service to unbind.-->
      </div>
      <!--<div class="submit bg-color-blue" @click="upadte">Unbind</div>-->
      <div class="submit" style="background: #CCC">Unbind</div>

    </div>
  </div>
</template>
<script>
import {
  recharge_bind_cash,
  recharge_info,
  recharge_ubind_cash
} from "../../api/user";
import navTitle from "@components/navTitle";

export default {
  name: "myPay",
  components: { navTitle },
  props: {},
  watch: {
    cashName(n, o) {
      console.log(n, o);
      let list = this.my_cash;
      for (let i = 0; i < list.length; i++) {
        if (list[i].type == n) {
          this.select_cash = list[i];
          this.showSubmit = false;
          return;
        }
      }
      this.showSubmit = true;
    }
  },
  data: function() {
    return {
       icon_moeny:this.global.moeny,
      payList: {},
      my_cash: [], //已经绑定的电子钱包
      select_cash: [],

      showSubmit: true, //默认显示新增绑定
      cashName: "",
      post: {
        cashName: "",
        name: "",
        phone: ""
      },
      removeData: {},
      banks: ["Gcash", "juanCash"]
    };
  },
  mounted: function() {
    this.getList();
  },
  methods: {
    getList() {
      recharge_info().then(res => {
        // console.log('getList',res.data)
        this.payList = res.data.types;
        this.my_cash = res.data.my_cash;
        // this.cashName = ""
        // this.showSubmit = true
        // this.removeData = {}
      });
    },
    submitted() {
      if (!this.cashName) {
        this.$dialog.toast({ mes: "Please select an cash platform" });
        return;
      }
      if (!this.post.name) {
        this.$dialog.toast({ mes: "Please enter username" });
        return;
      }
      if (!this.post.phone) {
        this.$dialog.toast({ mes: "Please enter phone number" });
        return;
      }
      this.$dialog.loading.open("Loading...");

      recharge_bind_cash({
        type: this.cashName,
        phone: this.post.phone,
        account: this.post.name
      })
        .then(res => {
          this.$dialog.loading.close();
          // console.log('绑定账户',res)
          this.$dialog.success("Link success，You get "+this.data.icon_moeny+res.data.money)+".";
          setTimeout(function () {
            location.reload();
          },3000)

          // location.reload();
          // this.getList()
        })
        .catch(res => {
          this.$dialog.loading.close();
          this.$dialog.error(res.msg);
        });
    },
    upadte() {

      if (!this.cashName) {
        this.$dialog.toast({ mes: "Please select an cash platform" });
        return;
      }
      if (!this.removeData.phone) {
        this.$dialog.toast({ mes: "Please enter your phone" });
        return;
      }
      this.$dialog.loading.open("Loading...");
      recharge_ubind_cash(this.select_cash.id, {
        phone: this.removeData.phone
      })
        .then(res => {
          this.$dialog.loading.close();
          // console.log('绑定账户',res)
          this.$dialog.success("Link success");
          // this.getList()
          location.reload();
        })
        .catch(res => {
          this.$dialog.loading.close();
          this.$dialog.error(res.msg);
        });
    }
  }
};
</script>
<style scoped>
.cash-withdrawal {
  padding: 0 0.3rem;
  box-sizing: border-box;
  /*background: #FAFAFA;*/
}
.row-T1 {
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  padding-left: 0.27rem;
  box-sizing: border-box;
}
.row-info {
  width: 100%;
  height: 0.5rem;
  line-height: 0.5rem;
  padding-left: 0.27rem;
  box-sizing: border-box;
  color: #999;
  margin-top: -10px;
}
.value-item {
  width: 100%;
  /*height: 5rem;*/
  background: #fff;
  padding: 0.27rem 0.27rem 0 0.27rem;
  box-sizing: border-box;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
}
.value-item .flex {
  display: flex;
  width: 100%;
  height: 1.2rem;
  border-bottom: 1px solid #eee;
}
.value-item .T1 {
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
}

.value-item .flex .I1 {
  width: 0.4rem;
  font-size: 0.85rem;
  line-height: 1.2rem;
  height: 1.2rem;
}
.value-item .flex input {
  width: 6rem;
  border: none;
  line-height: 1.2rem;
  height: 1.2rem;
  font-size: 0.65rem;
  padding-left: 0.25rem;
  box-sizing: border-box;
}

.value-item .max {
  width: 100%;
  line-height: 1rem;
  height: 1rem;
}

.value-item .min {
  width: 100%;
  line-height: 0.5rem;
  height: 0.5rem;
}

.href {
  color: #0c7cd8;
}
.row-wrap {
  /*margin-bottom: 0.3rem;*/
}
.row {
  width: 100%;
  padding: 0 0.27rem;
  box-sizing: border-box;
  background: #fff;
  height: 1rem;
  line-height: 1rem;
  display: flex;
  position: relative;
}
.row::after {
  content: "";
  position: absolute;
  width: calc(100% - 0.27rem - 0.27rem);
  bottom: 0px;
  left: 0;
  right: 0;
  margin: 0 auto;
  height: 1px;
  background: #eee;
}
.row .row-name {
  width: 2.5rem;
}
.row .input {
  flex: 1;
  display: block;
  height: 1rem;
  line-height: 1rem;
  box-sizing: border-box;
  padding-left: 0.15rem;
  border: none;
  background: #fff;
}
.row .select {
  flex: 1;
  display: block;
  height: 1rem;
  line-height: 1rem;
  box-sizing: border-box;
  padding-left: 0.15rem;
  border: none;
  background: #fff;
}
.submit {
  width: 100%;
  height: 0.92rem;
  background: rgba(0, 195, 249, 1);
  border-radius: 7px;
  color: #fff;
  line-height: 0.92rem;
  text-align: center;
  font-size: 0.35rem;
  margin-top: 1rem;
}

.tips {
  margin-top: 10px;
  color: #999;
}
</style>
